export const SOURCE_OPTIONS = [
  ["google", "Google"], ["indicacao", "Indicação"], ["redes_sociais", "Redes sociais"],
  ["passou_na_frente", "Passou na frente"], ["pos_venda", "Pós-venda"], ["ja_cliente", "Já é cliente"], ["importado", "Importado"], ["outro", "Outro"],
];
export const SOURCE_LABELS = { ...Object.fromEntries(SOURCE_OPTIONS), nao_informado: "Não informado" };
